// Arquivo gerado por scripts/generate-build-info.js. Nao edite manualmente.
export const BUILD_INFO = {
  "version": "10.0.1",
  "revision": "2ea0b5d5",
  "builtAt": "2026-10-09T23:29:13.190Z",
  "buildId": "10.0.1-2ea0b5d5-2026-10-09T23:29:13.190Z"
};
